module.exports = __webpack_public_path__ + "img/shop_tmall.f3eee095.png";